// Generic channel rows match any provider. Provider-specific rows (WhatsApp
// Cloud, Gmail and Outlook) only match an inbox from that provider.

// Returns the matching inbox (not a boolean) so callers can show the connected
// account's real name rather than the detected handle.
export const findConnectedInbox = (inboxes, stub) =>
  inboxes.find(
    inbox =>
      inbox.channel_type === stub?.channel_type &&
      (!stub?.provider || inbox.provider === stub.provider)
  );

export const isChannelConnected = (inboxes, stub) =>
  Boolean(stub) && Boolean(findConnectedInbox(inboxes, stub));
